var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.versionIsNewer)?_c('div',{staticClass:"form-error p-2 border-radius"},[_vm._v(" "+_vm._s(_vm.$t('versionIsTooOld', {version: _vm.version, projectName: _vm.projectName}))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }